import type { MarbleGame } from 'src/types/domain/Game'
import { getLatestEvent } from 'src/utils/raceUtils'
import { useGetHoveredGameId } from 'src/store/ui'
import { useHoveredGame } from 'src/hooks/useHoveredGame'
import { GameCard } from './GameCard'

type Props = Readonly<{
  game: MarbleGame
  onTrackClick: () => void
  isLoading: boolean
  isCurrentGame?: boolean
}>

export function GameCardContainer({
  game,
  onTrackClick,
  isLoading,
  isCurrentGame
}: Props) {
  const { onGameHover, onGameLeave, onGameTap } = useHoveredGame()
  const hoveredGameId = useGetHoveredGameId()
  const latestEvent = getLatestEvent(game.races[0].raceEvents)
  const preventNavigate = latestEvent?.eventType === 'race_scheduled'

  if (!latestEvent) {
    return null
  }

  return (
    <GameCard
      game={game}
      isCurrentGame={isCurrentGame}
      isHovered={hoveredGameId === game.id}
      isLoading={isLoading}
      key={game.id}
      latestEvent={latestEvent}
      onClick={() => { onGameTap(game.id, onTrackClick, preventNavigate) }}
      onMouseEnter={() => { onGameHover(game.id) }}
      onMouseLeave={onGameLeave}
    />
  )
}
